/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type UnassignConfigurationMutationVariables = Types.Exact<{
  input: Types.DisplayBulkUnassignConfigurationsInput;
}>;


export type UnassignConfigurationMutation = { __typename: 'Mutation', unassignConfiguration: string };


export const UnassignConfigurationDocument = gql`
    mutation unassignConfiguration($input: DisplayBulkUnassignConfigurationsInput!) {
  unassignConfiguration(input: $input)
}
    `;
export type UnassignConfigurationMutationFn = ApolloReactCommon.MutationFunction<UnassignConfigurationMutation, UnassignConfigurationMutationVariables>;

/**
 * __useUnassignConfigurationMutation__
 *
 * To run a mutation, you first call `useUnassignConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignConfigurationMutation, { data, loading, error }] = useUnassignConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignConfigurationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnassignConfigurationMutation, UnassignConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnassignConfigurationMutation, UnassignConfigurationMutationVariables>(UnassignConfigurationDocument, options);
      }
export type UnassignConfigurationMutationHookResult = ReturnType<typeof useUnassignConfigurationMutation>;
export type UnassignConfigurationMutationResult = ApolloReactCommon.MutationResult<UnassignConfigurationMutation>;
export type UnassignConfigurationMutationOptions = ApolloReactCommon.BaseMutationOptions<UnassignConfigurationMutation, UnassignConfigurationMutationVariables>;